(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Before-after"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.image-compare');
 
  containers.forEach(container => {
    const handle = container.querySelector('.slider-handle');
    const afterImage = container.querySelector('.after-image');
    const sliderLine = container.querySelector('.slider-line');
    let isDragging = false;
    let currentContainer = null;

    const moveSlider = (e) => {
      if (!isDragging || !currentContainer) return;
     
      e.preventDefault();
      const rect = currentContainer.getBoundingClientRect();
      const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
     
      // Check if the touch/click is within the container bounds
      if (clientX < rect.left || clientX > rect.right) return;
     
      const x = clientX - rect.left;
      const position = Math.max(0, Math.min(x / rect.width * 100, 100));
     
      handle.style.left = `${position}%`;
      sliderLine.style.left = `${position}%`;
      afterImage.style.clipPath = `polygon(${position}% 0, 100% 0, 100% 100%, ${position}% 100%)`;
    };

    const startDragging = (e) => {
      e.preventDefault();
      isDragging = true;
      currentContainer = container;
      moveSlider(e);
    };

    const stopDragging = () => {
      isDragging = false;
      currentContainer = null;
    };

    // Add touch events only to the container
    container.addEventListener('mousedown', startDragging);
    container.addEventListener('touchstart', startDragging, { passive: false });
   
    // Add move and end events to window to handle cases where cursor moves outside container
    window.addEventListener('mousemove', moveSlider);
    window.addEventListener('touchmove', moveSlider, { passive: false });
   
    window.addEventListener('mouseup', stopDragging);
    window.addEventListener('touchend', stopDragging);
   
    // Add touch cancel event for better mobile handling
    window.addEventListener('touchcancel', stopDragging);
  });
});

  } catch(e) { console.error(e); }
})();
})();
